module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-06.9e2a72bb.png";